export var RecipientEmailEnum;
(function (RecipientEmailEnum) {
    RecipientEmailEnum["Contact"] = "contact";
    RecipientEmailEnum["ContactAts"] = "contact_ats";
    RecipientEmailEnum["Recruitment"] = "recruitment";
    RecipientEmailEnum["Business"] = "business";
    RecipientEmailEnum["DailyRp"] = "daily_rp";
    RecipientEmailEnum["PasscarriereLp"] = "passcarriere_lp";
    RecipientEmailEnum["AtsLp"] = "ats_lp";
    RecipientEmailEnum["Blog"] = "blog";
    RecipientEmailEnum["Account"] = "account";
    RecipientEmailEnum["Fibii"] = "fibii";
    RecipientEmailEnum["Protect"] = "protect";
    RecipientEmailEnum["Moulteampass"] = "moulteampass";
    RecipientEmailEnum["UnJeuneUneSolution"] = "unjeuneunesolution";
    RecipientEmailEnum["Dpo"] = "dpo";
    // Wizbii Drive
    RecipientEmailEnum["Drive"] = "drive";
    RecipientEmailEnum["DriveCall"] = "drive_call";
    // Loyalty
    RecipientEmailEnum["CampusServices"] = "campus_services";
    RecipientEmailEnum["Boost"] = "boost";
    RecipientEmailEnum["Bnp"] = "bnp";
    RecipientEmailEnum["Soge"] = "soge";
    RecipientEmailEnum["SogeV2"] = "sogev2";
    RecipientEmailEnum["Cat31"] = "cat31";
    RecipientEmailEnum["Capg"] = "capg";
    RecipientEmailEnum["Cans"] = "cans";
    RecipientEmailEnum["Cavdf"] = "cavdf";
    RecipientEmailEnum["Cacf"] = "cacf";
    RecipientEmailEnum["Can"] = "can";
})(RecipientEmailEnum || (RecipientEmailEnum = {}));
